export default __webpack_public_path__ + "static/media/small_cv_sample5.c192f233.png";